// extracted by mini-css-extract-plugin
export var sliderRange = "_mt-2";
export var sliderRoot = "_mt-0";
export var sliderThumb = "_mt-3";
export var sliderTrack = "_mt-1";